import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_ENTITY_SETTING } from "@/constants/resultsLimits";

/**
 * Database-wide settings are stored against Geotab's placeholder device id. The entity type
 * alone is rejected ("At least one search field is required"), so the id has to come with it.
 */
const GLOBAL_ENTITY_ID = "NoDeviceId";

/** The database-wide settings, among them the tachograph readout intervals. */
export function useGlobalEntitySettings() {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery({
    queryKey: ["globalEntitySettings", activeSessionId],

    queryFn: ({ signal }) =>
      geotabClient.get(
        "EntitySetting",
        { entityType: "Global", entityId: GLOBAL_ENTITY_ID },
        RESULTS_LIMIT_ENTITY_SETTING,
        signal,
      ),
  });
}
